<html>
  <head>
    <title>SSO Login</title>
  </head>
  <body>
    <div>
      <div [hidden]="!settingUpUser">
        <div class="wm-l-login-spinner-wrapper">
          <div class="wm-l-login-spinner-msg">Please stand by. webmate is preparing your user ...</div>
          <p-progressSpinner class="wm-l-login-spinner"></p-progressSpinner>
        </div>
      </div>
      <div class="message" [ngClass]="{'hidden': !setupCompleted}">
        <img src="assets/img/happycat.svg">
        @if (!migrateUser) {
          <div class="label">Your user has been set up successfully.</div>
        }
        @if (migrateUser) {
          <div class="label">Your user has been migrated to SSO successfully. You can now log-in using e-mail or SSO</div>
        }
      </div>
      <div class="message" [ngClass]="{'hidden': !setupFailed}">
        <img src="assets/img/sadcat.svg">
        <div class="label">Setting up your user has failed. Please contact support.</div>
      </div>
      <div class="message" [ngClass]="{'hidden': !ssoInitiationFailure}">
        <img src="assets/img/sadcat.svg">
        <div class="label">There was an error initiating Single-Sign-On: {{ssoInitiationFailure}}</div>
      </div>
    </div>
  </body>
</html>
